import qs from "qs";
const API_HOST = process.env.REACT_APP_API_HOST;

function getAccessToken() {
  if (typeof window === "undefined") return "";

  return window.localStorage.getItem("token");
}

const api = {
  getFullUrl: (endpoint, query) => {
    const access_token = getAccessToken();

    const params = { ...query, access_token };

    return `${API_HOST}/${endpoint}?${qs.stringify(params)}`;
  },
  get: async (endpoint, query) => {
    const access_token = getAccessToken();

    const params = { ...query, access_token };

    const url = `${API_HOST}/${endpoint}?${qs.stringify(params)}`;

    return fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(res => {
        // console.log("API RESPONSE", { res });
        return res.data || res;
      })
      .catch(res => {
        console.log("API ERROR", res);
        return null;
      });
  },

  post: async (endpoint, data) => {
    const access_token = getAccessToken();

    const url = `${API_HOST}/${endpoint}?access_token=${access_token}`;
    // console.log("API REQUEST", url, { data });

    return fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data }),
    })
      .then(res => res.json())
      .then(res => {
        // console.log("API RESPONSE", { res });
        return Object.keys(res).includes("data") ? res.data : res;
      })
      .catch(res => {
        console.log("API ERROR", res);
        return null;
      });
  },
};

export default api;
